import React, { useEffect } from "react";

function AccordionFromHtml({ htmlContent }) {
  useEffect(() => {
    const buttons = document.querySelectorAll(".btn-semestre");

    function toggleAccordion(e) {
      const button = e.currentTarget;
      const content = button.nextElementSibling;
      const isOpen = content.style.display === "block";

      // Cerrar todos los contenidos
      document.querySelectorAll(".link1.whitebg").forEach((el) => {
        el.style.display = "none";
      });

      // Abrir el contenido clickeado si estaba cerrado
      if (!isOpen) {
        content.style.display = "block";
      }
    }

    buttons.forEach((btn) => {
      btn.addEventListener("click", toggleAccordion);
    });

    // Ocultar todos al inicio
    document.querySelectorAll(".link1.whitebg").forEach((el) => {
      el.style.display = "none";
    });

    // Cleanup event listeners on unmount
    return () => {
      buttons.forEach((btn) => {
        btn.removeEventListener("click", toggleAccordion);
      });
    };
  }, [htmlContent]);

  return (
    <div
  
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}

export default AccordionFromHtml;
